import { useState, useRef, useEffect } from "react";

let currentIndex = 0;

const OTPBox = ({ id, type, setOtpFunc }) => {
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [activeIndex, setActiveIndex] = useState(0);
  const inputRef = useRef();
  const handleOnChange = (event) => {
    let target = event.target;
    let newOtp = [...otp];
    let value = target.value;
    newOtp[currentIndex] = value.substring(value.length - 1);
    if (!value) {
      setActiveIndex(currentIndex - 1);
    } else {
      setActiveIndex(currentIndex + 1);
    }
    setOtp(newOtp);
    setOtpFunc(newOtp.join(""));
  };
  const handleOnKeyDown = (event) => {
    let target = event.target;
    let id_ = parseInt(target.id);
    currentIndex = id_ - 1;
    if (event.key == "Backspace") {
      setActiveIndex(currentIndex - 1);
    }
  };

  //   console.log(activeIndex);

  useEffect(() => {
    inputRef.current?.focus();
  }, [activeIndex]);
  return (
    <div className="grid grid-cols-6 gap-x-1">
      <input
        ref={1 == activeIndex + 1 ? inputRef : null}
        id={"1"}
        type="text"
        inputMode="numeric"
        className="rounded-md text-center shadow-md py-2 md:py-4 text-[14px] leading-tight focus:outline-none focus:shadow-orange-600 focus:border-none"
        onChange={handleOnChange}
        onKeyDown={handleOnKeyDown}
        value={otp[0]}
      />
      <input
        ref={2 == activeIndex + 1 ? inputRef : null}
        id={"2"}
        type="text"
        inputMode="numeric"
        className="rounded-md text-center shadow-md py-2 md:py-4 text-[14px] leading-tight focus:outline-none focus:shadow-orange-600 focus:border-none"
        onChange={handleOnChange}
        onKeyDown={handleOnKeyDown}
        value={otp[1]}
      />
      <input
        ref={3 == activeIndex + 1 ? inputRef : null}
        id={"3"}
        type="text"
        inputMode="numeric"
        className="rounded-md text-center shadow-md py-2 md:py-4 text-[14px] leading-tight focus:outline-none focus:shadow-orange-600 focus:border-none"
        onChange={handleOnChange}
        onKeyDown={handleOnKeyDown}
        value={otp[2]}
      />
      <input
        ref={4 == activeIndex + 1 ? inputRef : null}
        id={"4"}
        type="text"
        inputMode="numeric"
        className="rounded-md text-center shadow-md py-2 md:py-4 text-[14px] leading-tight focus:outline-none focus:shadow-orange-600 focus:border-none"
        onChange={handleOnChange}
        onKeyDown={handleOnKeyDown}
        value={otp[3]}
      />
      <input
        ref={5 == activeIndex + 1 ? inputRef : null}
        id={"5"}
        type="text"
        inputMode="numeric"
        className="rounded-md text-center shadow-md py-2 md:py-4 text-[14px] leading-tight focus:outline-none focus:shadow-orange-600 focus:border-none"
        onChange={handleOnChange}
        onKeyDown={handleOnKeyDown}
        value={otp[4]}
      />
      <input
        ref={6 == activeIndex + 1 ? inputRef : null}
        id={"6"}
        type="text"
        inputMode="numeric"
        className="rounded-md text-center shadow-md py-2 md:py-4 text-[14px] leading-tight focus:outline-none focus:shadow-orange-600 focus:border-none"
        onChange={handleOnChange}
        onKeyDown={handleOnKeyDown}
        value={otp[5]}
      />
    </div>
  );
};

export default OTPBox;
